import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkd036aRequest, Sgkd036aResponse, SGKD036AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSgkd036aService {
  /** 支払方法変更_受付中返却結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Sgkd036aResponse>();

  /**
  * 支払方法変更_受付中返却結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSgkb036aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB036AService} SGKB036AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSgkb036aService
   */
  constructor(
    private sGKB036AService: SGKD036AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 支払方法変更_受付中返却API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb036aResponse>}
   * @memberof UsedSgkb122dSgkb036aService
   */
  searchContractor(value: Sgkd036aRequest): Observable<Sgkd036aResponse> {
    // 検索条件を保存
    return this.sGKB036AService.sGKD036APost(<Sgkd036aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKD036A);
          return throwError(err.message);
        })
      );
  }
}
